const tooltipStyles = {
  baseStyle: {
    zIndex: "2001",
  },
};

export default tooltipStyles;
